import React, { useState, useEffect } from "react";
import PhotoItem from "../PhotoItem";

const AffichageRealisationsPresta = ({prestataire}) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const [index, setIndex] = useState(0);
  const [realisations, setRealisations] = useState([]);

  useEffect(() => {
    if (prestataire?.realisations) {
      setRealisations(prestataire.realisations);
      if (index >= prestataire.realisations.length) setIndex(0);
    }
  }, [prestataire, index]);

  if (!realisations || realisations.length === 0) {
    return <p style={{ marginTop: "20px" }}>Aucune réalisation disponible.</p>;
  }

  const currentRea = realisations[index];

  const prev = () => setIndex((i) => (i > 0 ? i - 1 : i));
  const next = () => setIndex((i) => (i < realisations.length - 1 ? i + 1 : i));

  const urlImgPhotosRea = apiUrl + "/api/files/?categorie=realisations&file=";

  return (
    <div style={{ maxWidth: "650px", margin: "30px auto" }}>
      <div style={cardStyle}>
        <h2>{currentRea.titreRealisation}</h2>
        <p>{currentRea.descriptionRealisation}</p>

        <div style={photoContainerStyle}>
          {currentRea.photosRealisation.map((photo, i) => (
            <PhotoItem
              key={i}
              photo={{
                url: photo.file ? photo.preview : urlImgPhotosRea + photo.photoName,
              }}
            />
          ))}
        </div>
      </div>

      {realisations.length > 1 && (
        <div style={navContainerStyle}>
          <button disabled={index === 0} onClick={prev} style={navBtnStyle}>
            ◀ Précédent
          </button>
          <span>
            {index + 1} / {realisations.length}
          </span>
          <button
            disabled={index === realisations.length - 1}
            onClick={next}
            style={navBtnStyle}
          >
            Suivant ▶
          </button>
        </div>
      )}
    </div>
  );
};

export default AffichageRealisationsPresta;

/* --- Styles --- */
const cardStyle = {
  background: "#fff",
  padding: "20px",
  borderRadius: "12px",
  boxShadow: "0 3px 15px rgba(0,0,0,0.15)",
  marginBottom: "20px",
};

const photoContainerStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "12px",
  marginTop: "10px",
};

const navContainerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "15px",
  marginTop: "15px",
};

const navBtnStyle = {
  padding: "6px 12px",
  borderRadius: "6px",
  border: "none",
  background: "#007bff",
  color: "white",
  cursor: "pointer",
  fontWeight: "bold",
};
